export default __webpack_public_path__ + "static/media/2924.622af50c.png";